import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

export interface SiteContentHome {
  heroTitle: string;
  heroSubtitle: string;
  heroImage: string;
  heroImages?: string[];
  logoImage?: string;
  featuredTitle: string;
  featuredSubtitle: string;
  announcement: string;
}

export interface SiteContentAbout {
  title: string;
  subtitle: string;
  story: string;
  values: string[];
  teamPhoto: string;
}

export interface SiteContentLocation {
  address: string;
  phone: string;
  email: string;
  hours: { day: string; time: string }[];
  mapEmbed: string;
  socials: { instagram: string; facebook: string; twitter: string };
}

export interface SiteContentBlog {
  heroTitle: string;
  heroSubtitle: string;
  heroImage: string;
}

export interface SiteSettings {
  maintenanceMode: boolean;
}

@Injectable({ providedIn: 'root' })
export class ContentService {
  constructor(private http: HttpClient) {}

  getHomeContent(): Observable<SiteContentHome | any> {
    return this.http.get<SiteContentHome>(`${API_URL}/api/bakery/content/home`).pipe(catchError(() => of({})));
  }

  getBlogContent(): Observable<SiteContentBlog | any> {
    return this.http.get<SiteContentBlog>(`${API_URL}/api/bakery/content/blog`).pipe(catchError(() => of({})));
  }

  getSettingsContent(): Observable<SiteSettings | any> {
    return this.http.get<SiteSettings>(`${API_URL}/api/bakery/content/settings`).pipe(catchError(() => of({})));
  }

  getAboutContent(): Observable<SiteContentAbout | any> {
    return this.http.get<SiteContentAbout>(`${API_URL}/api/bakery/content/about`).pipe(catchError(() => of({})));
  }

  getContactContent(): Observable<any> {
    return this.http.get<any>(`${API_URL}/api/bakery/content/contact`).pipe(catchError(() => of({})));
  }

  getLocationContent(): Observable<SiteContentLocation | any> {
    return this.http.get<SiteContentLocation>(`${API_URL}/api/bakery/content/location`).pipe(catchError(() => of({})));
  }

  updateContent(key: string, value: any, headers: any): Observable<any> {
    return this.http.put(`${API_URL}/api/bakery/content/${key}`, value, { headers });
  }

  submitContactForm(data: any): Observable<any> {
    return this.http.post(`${API_URL}/api/bakery/contact`, data);
  }

  uploadImage(file: File, headers: HttpHeaders): Observable<{ imageUrl: string }> {
    const formData = new FormData();
    formData.append('image', file);
    const uploadHeaders = new HttpHeaders({ Authorization: headers.get('Authorization') || '' });
    return this.http.post<{ imageUrl: string }>(`${API_URL}/api/bakery/upload`, formData, { headers: uploadHeaders });
  }
}
